module.exports = __webpack_public_path__ + "static/media/tn-mpants-knee-tight.e8dc48ad.svg";